window.luiReferenceControllers = window.luiReferenceControllers || [];
window.luiReferenceControllers.push(function (application, Stimulus) {
    application.register("comp_references_single_rodinne_baleni", class extends Stimulus.Controller {
    async connect() {
        const self = this;

        this._cards = self.targets.findAll('card')
        this._gsapTweens = [];
        await importScript([cdnjs.gsap, cdnjs.gsapScrollTrigger]);
        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.matchMedia({
            '(min-width: 60em)': () => {
                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: self.targets.find('scene'),
                        start: 'top-=200 top',
                        end: `+${100 * self._cards.length}%`,
                        scrub: true,
                        pin: true,
                        markers: false
                    }
                })

                this._gsapTweens.push(timeline)

                self._cards.forEach((card) => {
                    ScrollTrigger.saveStyles(card)
                })

                timeline.fromTo(self._cards[0],
                    {
                        translateY: 0,
                        scale: 1,
                    },
                    {
                        translateY: '-21%',
                        scale: 0.8
                    }
                )

                timeline.fromTo(self._cards[1],
                    {
                        translateY: '100%',
                        scale: 1,
                    },
                    {
                        translateY: '-5.5%',
                        scale: 0.9
                    },
                    '>-85%'
                )

                timeline.fromTo(self._cards[2],
                    {
                        translateY: '100%'
                    },
                    {
                        translateY: '11%'
                    },
                    '>-25%'
                )
            }
        })
    }

    playVideo({currentTarget}) {
        arguments[0].preventDefault()

        const video = currentTarget.closest('[data-ref="video"]').querySelector('video');

        if(video !== null) {
            video.play()
            currentTarget.style.opacity = 0
            currentTarget.style.pointerenter = 'none'
        }
    }

    resetVideo({currentTarget}) {
        const button = currentTarget.closest('[data-ref="video"]').querySelector('[data-ref="playButton"]');

        if(button !== null) {
            button.style.opacity = null
            button.style.pointerenter = null
        }
    }

    disconnect() {
        if (!this._gsapTweens) {
            return
        }

        this._gsapTweens.forEach((tween) => {
            if (tween.scrollTrigger) {
                tween.scrollTrigger.kill()
            }

            tween.kill()
        })

        this._gsapTweens = []
    }
})
});
window.luiRegisterReferenceControllers && window.luiRegisterReferenceControllers();
